(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bg-wholesale-quick-order"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bg-wholesale-order')) {
  customElements.define('bg-wholesale-order', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized || !this.querySelector('[data-add-selection]')) return;
      this.initialized = true;
      this.rows = Array.from(this.querySelectorAll('[data-order-row]'));
      this.families = Array.from(this.querySelectorAll('[data-order-family]'));
      this.familyRows = new Map(this.families.map(family => [family, []]));
      this.rows.forEach(row => {
        this.familyRows.get(row.closest('[data-order-family]'))?.push(row);
        row.orderSearch = row.dataset.search.toLocaleLowerCase();
      });
      this.button = this.querySelector('[data-add-selection]');
      this.buttonLabel = this.button.textContent;
      this.message = this.querySelector('[data-order-message]');
      this.category = this.querySelector('[data-category-input]');
      this.format = new Intl.NumberFormat(document.documentElement.lang || 'en-AU', { style: 'currency', currency: this.dataset.currency || 'AUD' });
      Array.from(new Set(this.rows.map(r => r.dataset.category).filter(Boolean))).sort().forEach(label => {
        const option = document.createElement('option'); option.value = label; option.textContent = label; this.category.append(option);
      });
      this.addEventListener('input', event => {
        if (event.target.matches('[data-order-quantity]')) { this.updateTotals(); this.filterRows(); }
        else if (event.target.matches('[data-search-input]')) {
          clearTimeout(this.searchTimer);
          this.searchTimer = setTimeout(() => this.filterRows(), 120);
        }
      });
      this.addEventListener('change', event => { if (event.target.matches('select,input[type=checkbox]')) this.filterRows(); });
      this.addEventListener('click', event => {
        const photo = event.target.closest('[data-variant-photo]');
        if (photo && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
          event.preventDefault();
          if (this.busy) return;
          const family = photo.closest('[data-order-family]');
          family.querySelector('[data-box-choice]').value = photo.dataset.variantPhoto;
          this.filterRows();
          return;
        }
        const edit = event.target.closest('[data-edit-box]');
        if (!edit || this.busy) return;
        const family = edit.closest('[data-order-family]');
        family.querySelector('[data-box-choice]').value = edit.dataset.editBox;
        this.querySelector('[data-search-input]').value = '';
        this.filterRows(); family.querySelector('[data-box-choice]').focus();
      });
      this.querySelector('[data-clear]').addEventListener('click', () => {
        this.rows.forEach(r => { r.querySelector('[data-order-quantity]').value = '0'; });
        this.message.textContent = ''; this.updateTotals(); this.filterRows();
      });
      this.querySelector('[data-bulk-apply]').addEventListener('click', () => this.applyBulk());
      this.querySelector('[data-reset-filters]').addEventListener('click', () => {
        this.querySelector('[data-search-input]').value = ''; this.category.value = '';
        this.querySelector('[data-stock-input]').checked = false; this.querySelector('[data-selected-input]').checked = false; this.filterRows();
      });
      this.button.addEventListener('click', () => this.addSelection());
      this.updateTotals(); this.filterRows();
    }
    disconnectedCallback() { clearTimeout(this.searchTimer); }
    parseBulk(text) {
      const lines = text.split(/\r?\n/).map((value, index) => ({ value: value.trim(), number: index + 1 })).filter(line => line.value);
      if (!lines.length) return { entries: [], errors: [{ key: 'empty' }] };
      if (lines.length > 500 || text.length > 30000) return { entries: [], errors: [{ key: 'tooMany' }] };
      const bySku = new Map();
      this.rows.forEach(row => {
        const sku = (row.dataset.sku || '').trim().toUpperCase();
        if (sku) bySku.set(sku, [...(bySku.get(sku) || []), row]);
      });
      const quantities = new Map(), errors = [];
      lines.forEach((line, index) => {
        const fields = line.value.split(/[\t,;]/).map(value => value.trim().replace(/^"(.*)"$/, '$1'));
        if (index === 0 && fields.length === 2 && /^(sku|item code)$/i.test(fields[0]) && /^(quantity|qty)$/i.test(fields[1])) return;
        if (fields.length !== 2 || !fields[0] || !/^\d+$/.test(fields[1]) || !Number.isSafeInteger(Number(fields[1]))) { errors.push({ line: line.number, key: 'format' }); return; }
        const rows = bySku.get(fields[0].toUpperCase()) || [];
        if (rows.length !== 1) { errors.push({ line: line.number, key: rows.length ? 'ambiguous' : 'missing' }); return; }
        const row = rows[0], value = Number(fields[1]);
        if (value > 0 && row.dataset.available !== 'true') { errors.push({ line: line.number, key: 'unavailable' }); return; }
        const previous = quantities.get(row);
        quantities.set(row, { row, value: (previous ? previous.value : 0) + value, line: line.number });
      });
      quantities.forEach(entry => {
        const field = entry.row.querySelector('[data-order-quantity]');
        if (!this.quantity({ value: String(entry.value), max: field.max, dataset: field.dataset, setAttribute() {} }).valid) errors.push({ line: entry.line, key: 'quantity' });
      });
      if (!quantities.size && !errors.length) errors.push({ key: 'empty' });
      return { entries: Array.from(quantities.values()), errors };
    }
    applyBulk() {
      if (this.busy) return;
      const result = this.parseBulk(this.querySelector('[data-bulk-input]').value);
      const message = this.querySelector('[data-bulk-message]'), errors = this.querySelector('[data-bulk-errors]');
      errors.replaceChildren();
      if (result.errors.length) {
        message.textContent = this.dataset.bulkError;
        result.errors.forEach(error => {
          const item = document.createElement('li');
          const text = this.dataset['bulk' + error.key[0].toUpperCase() + error.key.slice(1)];
          item.textContent = error.line ? this.dataset.bulkLine.replace('__line__', String(error.line)).replace('__message__', text) : text;
          errors.append(item);
        });
        return;
      }
      result.entries.forEach(entry => { entry.row.querySelector('[data-order-quantity]').value = String(entry.value); });
      this.updateTotals(); this.filterRows();
      message.textContent = this.dataset.bulkSuccess.replace('__count__', String(result.entries.length));
    }
    quantity(input) {
      const raw = input.value.trim();
      const number = raw === '' ? 0 : Number(raw);
      const minimum = Number(input.dataset.minimum) || 1;
      const increment = Number(input.dataset.increment) || 1;
      const maximum = input.max ? Number(input.max) : Infinity;
      const valid = Number.isSafeInteger(number) && number <= 2147483647 && number >= 0 && (number === 0 || (number >= minimum && number <= maximum && number % increment === 0));
      input.setAttribute('aria-invalid', String(!valid));
      return { valid, value: valid ? number : 0 };
    }
    updateTotals() {
      let total = 0, units = 0, lines = 0;
      this.rows.forEach(row => {
        const quantity = this.quantity(row.querySelector('[data-order-quantity]')).value;
        const amount = Number(row.dataset.price) * quantity;
        total += amount; units += quantity; if (quantity > 0) lines++;
        row.querySelector('[data-line-total]').textContent = this.format.format(amount / 100);
      });
      (this.families || []).forEach(family => {
        const list = family.querySelector('[data-family-selections]');
        list.replaceChildren();
        this.familyRows.get(family).forEach(row => {
          const n = this.quantity(row.querySelector('[data-order-quantity]')).value;
          if (!n) return;
          const edit = document.createElement('button'); edit.type = 'button';
          edit.dataset.editBox = row.dataset.id;
          edit.textContent = n + ' × ' + (row.dataset.choiceLabel || row.dataset.sku);
          list.append(edit);
        });
      });
      this.querySelector('[data-subtotal]').textContent = this.format.format(total / 100);
      this.querySelector('[data-unit-count]').textContent = String(units);
      this.querySelector('[data-line-count]').textContent = String(lines);
    }
    filterRows() {
      const query = this.querySelector('[data-search-input]').value.toLocaleLowerCase().trim();
      const terms = query.split(/\s+/).filter(Boolean);
      const availableOnly = this.querySelector('[data-stock-input]').checked;
      const selectedOnly = this.querySelector('[data-selected-input]').checked;
      let count = 0;
      const matching = new Set();
      this.rows.forEach(row => {
        const text = row.orderSearch;
        const matches = terms.every(term => text.includes(term)) && (!this.category.value || row.dataset.category === this.category.value) && (!availableOnly || row.dataset.available === 'true') && (!selectedOnly || this.quantity(row.querySelector('[data-order-quantity]')).value > 0);
        row.hidden = !matches; if (matches) { count++; matching.add(row); }
      });
      if (this.families && this.families.length) {
        count = 0;
        this.families.forEach(family => {
          const rows = this.familyRows.get(family);
          const matches = rows.filter(row => matching.has(row));
          const choice = family.querySelector('[data-box-choice]');
          family.hidden = matches.length === 0;
          if (matches.length) {
            count++;
            if (!matches.some(row => row.dataset.id === choice.value)) choice.value = matches[0].dataset.id;
          }
          rows.forEach(row => { row.hidden = !matching.has(row) || row.dataset.id !== choice.value; });
          const matchingIds = new Set(matches.map(row => row.dataset.id));
          family.querySelectorAll('[data-variant-photo]').forEach(photo => {
            photo.hidden = !matchingIds.has(photo.dataset.variantPhoto);
            if (photo.dataset.variantPhoto === choice.value) photo.setAttribute('aria-current', 'true');
            else photo.removeAttribute('aria-current');
          });
          const selected = choice.selectedOptions?.[0];
          if (selected) {
            const photo = family.querySelector('[data-family-photo] img');
            if (photo && selected.dataset.image && photo.getAttribute('src') !== selected.dataset.image) { if (selected.dataset.srcset) photo.srcset = selected.dataset.srcset; photo.src = selected.dataset.image; photo.alt = selected.dataset.alt; }
            const link = family.querySelector('[data-family-photo]');
            if (link && selected.dataset.url) link.href = selected.dataset.url;
            const note = family.querySelector('[data-family-photo-note]');
            if (note) note.textContent = selected.dataset.photoNote;
          }
        });
      }
      this.querySelector('[data-result-count]').textContent = String(count);
      this.querySelector('[data-no-matches]').hidden = count > 0 || this.rows.length === 0;
    }
    async cartQuantities() {
      const response = await fetch(this.dataset.cartJson, { credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!response.ok) throw new Error(this.dataset.error);
      const cart = await response.json();
      const map = new Map(); (cart.items || []).forEach(item => map.set(String(item.variant_id), (map.get(String(item.variant_id)) || 0) + item.quantity));
      return map;
    }
    async addSelection() {
      if (this.busy) return;
      const items = []; let invalid = null, hasBundles = false;
      this.rows.forEach(row => {
        const input = row.querySelector('[data-order-quantity]');
        const quantity = this.quantity(input);
        if (!quantity.valid && !invalid) invalid = input;
        if (quantity.valid && quantity.value > 0 && !input.disabled) { items.push({ id: row.dataset.id, quantity: quantity.value }); if (row.dataset.bundle === 'true') hasBundles = true; }
      });
      if (invalid) { this.message.textContent = this.dataset.invalid; const row = invalid.closest('[data-order-row]'); row.hidden = false;
        const family = row.closest?.('[data-order-family]');
        if (family) { family.hidden = false; family.querySelector('[data-box-choice]').value = row.dataset.id; }
        invalid.focus(); return; }
      if (!items.length) { this.message.textContent = this.dataset.empty; return; }
      this.busy = true; this.button.disabled = true; this.button.textContent = this.dataset.adding;
      this.querySelectorAll('input,select,textarea,[data-clear],[data-bulk-apply],[data-reset-filters]').forEach(el => { el.dataset.wasDisabled = String(el.disabled); el.disabled = true; });
      this.message.textContent = '';
      let before, sent = false;
      try {
        before = await this.cartQuantities(); sent = true;
        const response = await fetch(this.dataset.add, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
        let result = {}; try { result = await response.json(); } catch (_) {}
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : this.dataset.error);
        window.location.assign(this.dataset.cart);
      } catch (error) {
        let reconciled = !sent;
        // Bundle cart responses can contain component lines. Never guess pack quantities after an uncertain write.
        if (sent && before && !hasBundles) {
          try {
            const after = await this.cartQuantities();
            this.rows.forEach(row => {
              const input = row.querySelector('[data-order-quantity]');
              const added = Math.max(0, (after.get(row.dataset.id) || 0) - (before.get(row.dataset.id) || 0));
              input.value = String(Math.max(0, this.quantity(input).value - added));
            });
            reconciled = true;
          } catch (_) {}
        }
        this.message.textContent = (error.message || this.dataset.error) + (sent ? ' ' + this.dataset.partial : '');
        this.querySelector('[data-review-cart]').hidden = !sent;
        this.querySelectorAll('[data-was-disabled]').forEach(el => { el.disabled = el.dataset.wasDisabled === 'true'; delete el.dataset.wasDisabled; });
        this.button.disabled = !reconciled; this.button.textContent = this.buttonLabel; this.busy = !reconciled;
        this.updateTotals(); this.message.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
